import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend';
import { asArray } from '@nu-art/ts-common';
import { ModuleFE_LogTemplate } from '../../../../../_entity/log-tempalte/ModuleFE_LogTemplate.js';
import './Renderer_LogTemplateHeader.scss';
export class Renderer_LogTemplateHeader extends ComponentSync {
    __onLogTemplatesUpdated = (...params) => {
        if (!this.mounted)
            return;
        const currentId = this.state.logTemplate?._id;
        const items = asArray(params[1]);
        const updated = items.find(item => item._id === currentId);
        if (updated)
            this.setState({ logTemplate: updated });
    };
    deriveStateFromProps(nextProps, state) {
        state.renderArgs = nextProps.renderArgs;
        if (state.renderArgs.itemId !== state.logTemplate?._id)
            state.logTemplate = ModuleFE_LogTemplate.cache.unique(state.renderArgs.itemId);
        return state;
    }
    render() {
        return _jsxs(LL_V_L, { className: 'log-template-header', children: [this.render_Title(), this.render_Subtitle()] });
    }
    render_Title = () => {
        return _jsx("div", { className: 'log-template-header__title', children: this.state.logTemplate?.label ?? 'N/A' });
    };
    render_Subtitle = () => {
        const logTemplate = this.state.logTemplate;
        if (!logTemplate?.title || logTemplate.title === logTemplate.label)
            return;
        return _jsx("span", { className: 'log-template-header__sub-title', children: logTemplate.title });
    };
}
//# sourceMappingURL=Renderer_LogTemplateHeader.js.map